// extracted by mini-css-extract-plugin
export var cardLayout = "_92-1";
export var paginationContainer = "_92-0";